/**
 * remove protocol
 * @param  {string} url
 * @return {string}
 */
__.removeProtocol = function(url) {
  return url.replace(/http(s)?:/, '');
};
